import isWeekend from 'date-fns/isWeekend';
import nextMonday from 'date-fns/nextMonday';
import { getDaysAdded } from './getDaysAdded';

export function getNextBusinessDay(date = new Date()) {
  const nextDay = getDaysAdded(date, 1);

  return isWeekend(nextDay) ? nextMonday(nextDay) : nextDay;
}
